// Public Profile action constants
export const SETTING_PUBLIC_PROFILE_PAGE_REQUEST = 'SETTING_PUBLIC_PROFILE_PAGE_REQUEST'
export const SETTING_PUBLIC_PROFILE_CHANGE_FORM = 'SETTING_PUBLIC_PROFILE_CHANGE_FORM'
export const SETTING_PUBLIC_PROFILE_REQUEST = 'SETTING_PUBLIC_PROFILE_REQUEST'
export const SETTING_PUBLIC_PROFILE_DISCARD_CHANGE = 'SETTING_PUBLIC_PROFILE_DISCARD_CHANGE'



// WEBPACK FOOTER //
// ./app/actions/setting/publicProfile/constants.js